module.exports = '<svg width="22" height="32" viewBox="0 0 22 32"><path d="M16.541 19.51h3.99c1.327 0 1.715-.844.864-1.77l-6.468-7.151h3.37c1.36 0 1.772-.414.922-1.495L12.459.712c-.849-1.079-2.223-.871-3.072.212l-6.76 8.157c-.849 1.079-.435 1.508.921 1.508H6.92L.452 17.738c-.851.928-.464 1.77.864 1.77h3.99L.451 24.875c-.851.928-.464 1.77.864 1.77h7.824v4.461c0 .492.4.892.892.892h1.784c.492 0 .892-.4.892-.892v-4.461h7.824c1.327 0 1.715-.844.864-1.77l-4.851-5.365z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/tree-1.js
// module id = 1459
// module chunks = 14